var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopOval3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 1168,
    viewBox: "0 0 1280 1168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_152_16056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M918.462 312.472C971.893 377.953 1059.69 678.071 898.529 809.57C737.372 941.07 388.291 854.154 334.861 788.674C281.43 723.193 245.036 604.43 406.193 472.931C557.942 330.371 865.032 246.991 918.462 312.472Z",
    fill: "url(#paint0_linear_152_16056)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_152_16056",
    x: 0.510498,
    y: 0.805664,
    width: 1279.35,
    height: 1166.22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 144.5,
    result: "effect1_foregroundBlur_152_16056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_16056",
    x1: 372.491,
    y1: 834.791,
    x2: 956.092,
    y2: 358.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD29",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552788,
    stopColor: "#FFCD29",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD29",
    stopOpacity: 0.04
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopOval3);
export default __webpack_public_path__ + "static/media/desktop-oval-3.0cf0b3163f1d4f93c222cfe27dd5ecd4.svg";
export { ForwardRef as ReactComponent };